<template>
  <v-card class="pa-2" v-if="ametnikuInfo?.ametnik || isLoading">
    <h3>Minu ametnik</h3>
    <div class="text-center" v-if="isLoading">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>

    <VoMinuAmetnik :ametnikuInfo="ametnikuInfo"></VoMinuAmetnik>

  </v-card>
</template>

<script lang="ts">
import { IsikuandmeTeenus } from '@/core/isikuandmed-teenus';
import { MinuAmetnik } from '@/models/Ametnik';
import { defineComponent } from 'vue';
import moment from 'moment';
import mixin from '@/core/mixins';
import { erandid } from '@/core/erandid';
import { useAmetnikStore } from '@/stores/ametnikStore';

const _isikuandmeTeenus = new IsikuandmeTeenus();

export default defineComponent({
  name: 'MinuAmetnik',
  data() {
    return {
      ametnikuInfo: new MinuAmetnik(),
      moment: moment,
      isLoading: false,
    }
  },
  mixins: [mixin],
  methods: {
    minuAmetnikuInfo() {
      if (this.ametnikStore.ametnikSaadud) {
        Object.assign(this.ametnikuInfo, this.ametnikStore.ametnik);
        this.isLoading = false;
      }
      else {
        this.isLoading = true;
      }

      _isikuandmeTeenus.minuAmetnikuInfo().then((ametnik) => {
        this.ametnikStore.satiAmetnik(ametnik);
        this.ametnikuInfo = ametnik;
      }).finally(() => {
        this.isLoading = false;
      });
    }
  },
  created() {
    this.moment = moment
  },
  mounted() {
    this.minuAmetnikuInfo();
  },
  setup() {
    return {
      erandid,
      ametnikStore: useAmetnikStore()
    }
  }
}
);
</script>